import * as status from '../actions/status.actions'

import { UXPage } from '../../core/models/ux-page'

export interface State {
    current: UXPage | null
    trail: UXPage[]
    currentId: string | null
    loading: boolean,
    loadProducts: boolean,
    showHeader: boolean
}

const initialState: State = {
    current: null,
    trail: [],
    currentId: null,
    loading: false,
    loadProducts: false,
    showHeader: false
}

export function reducer(
    state = initialState,
    action: status.Actions
) {
    switch(action.type) {
        case status.SET:
          return {
            ...state,
            loading: true
          }

        case status.APPLYSUCCESS:
          let page = action.payload && action.payload.current
          let trail = (action.payload && action.payload.trail) || []

          return {
              ...state,
              current: page,
              trail: trail,
              currentId: (page && page.id) || null,
              loading: false,
              loadProducts: action.payload.loadProducts
          }

        case status.SETHEADER:
          return {
            ...state,
            showHeader: action.payload
          }

        default:
            return state
    }
}

export const getCurrentPageType = (state: State) => state.current && state.current.type
export const getPageTrail = (state: State) => state.trail
export const getCurrentId = (state: State) => state.currentId
export const getCurrentPageParams = (state: State) => state && state.current && state.current.parameters
export const isStatusLoading = (state: State) => state.loading
export const loadProducts = (state: State) => state.loadProducts
export const showHeader = (state: State) => state.showHeader
